module.exports = __webpack_public_path__ + "img/comic2.jpg";